export enum NWEAIntentOption {
  YesAndSync = "Yes we administer MAP and would like to sync scores to Newsela",
  YesAndNoSync = "Yes we administer MAP but we do not want to sync scores",
  No = "No we do not administer MAP",
  MoreInfo = "I'd like to better understand this offering. Please send me more information.",
}
